import React, { FC, useCallback, useEffect, useState } from "react";
import MapComponent from "pages/MapComponent/MapComponent";
import OrderModal from "pages/OrderModal";
import MainModal from "components/MainModal";
import SignIn from "pages/SignIn";
import Profile from "pages/Profile";
import Preloader from "components/Preloader";
import { Box, Button } from "@mui/material";
import useIsMobile from "hooks/useIsMobile";
import { useAppSelector } from "store/hooks/useAppSelector";
import { ToastContainer } from "react-toastify";
import {
  useGetApiVersionQuery,
  useGetConfigQuery,
  useGetSettingsQuery,
} from "store/api";
import { useAppDispatch } from "store/hooks/useAppDispatch";
import { orderStatuses } from "pages/OrderModal/components/CreatedOrder/constants";
import {
  setAddCostIncrementValue,
  setApiVersion,
  setCardPaymentPermitted,
  setConfig,
  setCurrency,
} from "store/slices/settings";
import { shallowEqual } from "react-redux";
import {
  setCustomOptions,
  setFirstCustomOptions,
  setOptions,
} from "store/slices/options";
import orderStyles from "pages/OrderModal/OrderModal.styled";
import styles from "./PageRoot.styled";

export const PageRoot: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isProfileOpen, setIsProfileOpen] = useState<boolean>(false);
  const isMobile = useIsMobile();
  const auth = useAppSelector((state) => state.auth.token, shallowEqual);
  const orderDetails = useAppSelector(
    (state) => state.orderDetails,
    shallowEqual,
  );
  const dispatch = useAppDispatch();
  const { data: apiVersion, isSuccess: isApiVersionSuccess } =
    useGetApiVersionQuery();
  const { data: settings, isSuccess } = useGetSettingsQuery();
  const { data: config, isSuccess: isConfigSuccess } = useGetConfigQuery();

  useEffect(() => {
    if (isSuccess && settings) {
      dispatch(setCurrency(settings.currency));
      dispatch(setAddCostIncrementValue(settings.add_cost_increment_value));
      dispatch(setOptions(settings.extra_charge_codes));
      dispatch(setCardPaymentPermitted(settings.card_payment_permitted));
      dispatch(
        setFirstCustomOptions(settings.show_custom_extra_charges_before_system),
      );
      if (settings.custom_extra_charges.length) {
        dispatch(setCustomOptions(settings.custom_extra_charges));
      }
    }
  }, [settings, isSuccess]);

  useEffect(() => {
    if (isApiVersionSuccess && apiVersion) {
      dispatch(setApiVersion(apiVersion.version));
    }
  }, [apiVersion, isApiVersionSuccess]);

  useEffect(() => {
    if (isConfigSuccess && config) {
      dispatch(setConfig(config));
    }
  }, [config, isConfigSuccess]);

  const handleClose = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const handleToggleProfile = useCallback(() => {
    setIsProfileOpen((prev) => !prev);
  }, []);

  return (
    <>
      {!isMobile && (
        <Box sx={styles.contentWrap}>
          <MapComponent />
          <Button
            className="primaryBlack"
            sx={styles.btn}
            onClick={auth ? handleToggleProfile : handleClose}
          >
            {auth ? "Профіль" : "Вхід"}
          </Button>
          <Profile isOpen={isProfileOpen} onClose={handleToggleProfile} />
        </Box>
      )}
      <OrderModal />
      {orderDetails.id &&
        (orderDetails.status === orderStatuses[0].value ||
          orderDetails.status === orderStatuses[1].value) && <Preloader />}
      <MainModal
        isOpen={isOpen}
        handleClose={handleClose}
        sx={{ ...orderStyles.modal, ...styles.modal }}
      >
        <SignIn onSave={handleClose} />
      </MainModal>
      <ToastContainer icon={false} autoClose={5000} closeButton={false} />
    </>
  );
};

export default PageRoot;
